import { Injectable } from '@angular/core';
import { Client } from './client';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class RoutingMachineService {

  private cache = {};

  constructor(private client: Client, private http: HttpClient) { }

  route(coordinates: Coordinates): Observable<Route> {
    const key = `${coordinates.firstPoint.lng},${coordinates.firstPoint.lat};${coordinates.lastPoint.lng},${coordinates.lastPoint.lat}`;

    if (this.cache[key])
      return (Observable.of(this.cache[key]))
    else {
      let sub = new Subject<Route>();
      this.http.get(
        this.client.getRoutingMachineRouteUrl(key)
      ).subscribe((res: any) => {
        sub.next(res);
        if (Object.keys(this.cache).length > 1000) this.cache = {};
        this.cache[key] = res;
      });
      return sub.asObservable();
    }
  }

  routeAll(coordinates: Array<any>): Observable<Route> {
    return this.http.get(
      this.client.getRoutingMachineRouteUrl(coordinates.map(coord => `${coord.lng},${coord.lat}`).join(';'))
    ) as Observable<Route>;
  }

  routeTable(carCoordinates, ordersCoordinates) {
    const key = this.hashCode(JSON.stringify(carCoordinates) + JSON.stringify(ordersCoordinates.map(el => el.lat + el.lng)));
    if (this.cache[key])
      return (Observable.of(this.cache[key]))
    else {
      let sub = new Subject<Route>();

      this.http.get(this.client.getRoutingMachineTableUrl(
        [this.locToString(carCoordinates), ...ordersCoordinates.map(coord => this.locToString(coord))].join(';'),
        ordersCoordinates.map((el, index) => index + 1).join(';'))).subscribe((res: any) => {
          sub.next(res);
          if (Object.keys(this.cache).length > 5000) {
            this.cache = {}
          };
          this.cache[key] = res;
        }, error => {
          this.cache[key] = error;
        })
      return sub.asObservable();
    }
  }

  private hashCode(str) {
    var hash = 0;
    if (str.length == 0) {
      return hash;
    }
    for (var i = 0; i < str.length; i++) {
      var char = str.charCodeAt(i);
      hash = ((hash << 5) - hash) + char;
      hash = hash & hash; // Convert to 32bit integer
    }
    return hash;
  }

  private locToString(loc) {
    return `${loc.lng},${loc.lat}`;
  }


}



export interface Coordinates {
  firstPoint: LatLng;
  lastPoint: LatLng;
}

export interface LatLng {
  lat: number;
  lng: number;
}

export interface Route {
  code: string;
  routes: any[];
  waypoints: RouteWaypoint[];
}

export interface RouteWaypoint {
  hint: string;
  location: number[];
  name: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/services/routing-machine.service.ts